module.exports = __webpack_public_path__ + "b296e05d0932e16d500b753becdb338e.woff2";